
import React, { useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import AppHeader from "../components/AppHeader";
import ThirdWBS from "../components/ThirdWBS";
//import ThirdWBSRightPanel from "../components/ThirdWBSRightPanel";
//import NotationAccordionMatrixPanel from "../components/NotationAccordionMatrixPanel";
import NotationExcelSheet from "../components/NotationExcelSheet";
import MetricsAccordionTable from "../components/MetricsAccordionTable";

import {
  Panel,
  PanelGroup,
  PanelResizeHandle,
} from "react-resizable-panels";

const ThirdtabPanel = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();

  /* const projectName =
    location.state?.projectName || localStorage.getItem("projectName");
    
 */
const [projectName, setProjectName] = useState(
  location.state?.projectName || localStorage.getItem("projectName") || ""
);
  const userName = localStorage.getItem("userName");

  const [selectedActivityId, setSelectedActivityId] = useState<number | null>(null);
  const [selectedWbsId, setSelectedWbsId] = useState<number | null>(null);
  const [rightView, setRightView] = useState<"activity" | "wbs" | null>(null);
  const [activityLevel, setActivityLevel] = useState(1);
  const projectId = Number(id);

  return (
    // <div className="flex h-screen flex-col bg-gray-100">
    <div
  className="flex h-screen flex-col bg-gray-100"
  style={{
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: "13px",
    fontWeight: 400,
  }}
>
      
      <AppHeader
  title={projectName || id || "Third Panel"}
  userName={userName}
  activeTab="third"
  onBack={() => navigate(-1)}
  onHome={() => navigate("/projects")}
  onDashboard={() =>
    navigate(`/project/${id}`, {
      state: { projectName },
    })
  }
  onSecond={() =>
    navigate(`/project/${id}/second`, {
      state: { projectName },
    })
  }
  onThird={() =>
    navigate(`/project/${id}/third`, {
      state: { projectName },
    })
  }
  onFourth={() =>
  navigate(`/project/${id}/fourth`, {
    state: { projectName },
  })
}
onFifth={() =>
  navigate(`/project/${id}/fifth`, {
    state: { projectName },
  })
}
 /*  onLogout={() => {
    localStorage.removeItem("token");
    navigate("/login");
  }} */
/*  onLogout={() => {
  Object.keys(sessionStorage).forEach((key) => {
    if (
      key.startsWith("treeSelection-") ||
      key.startsWith("treeOpenNodes-")
    ) {
      sessionStorage.removeItem(key);
    }
  });

  localStorage.removeItem("token");
  navigate("/login");
}} */
onLogout={() => {
  sessionStorage.clear();

  localStorage.removeItem("token");

  navigate("/login");
}}
  projectId={Number(id)}
  onProjectUpdated={(updatedName) => {
    setProjectName(updatedName);
  }}
/>

      <div className="flex-1 min-h-0 overflow-hidden ">
       
   
        <PanelGroup
  direction="horizontal"
  autoSaveId="third-tab-layout"
  className="flex h-full min-h-0 overflow-hidden"
>
  {/* LEFT PANEL */}
  <Panel defaultSize={25} minSize={15}>
    <div
      className="flex h-full min-h-0 flex-col overflow-hidden"
      style={{ backgroundColor: "#FFFFFF" }}
    >
      <div
        //className="flex shrink-0 items-center justify-between px-4 py-3"
        className="flex shrink-0 items-center justify-between px-4 py-2"
        style={{ backgroundColor: "#FFFFFF" }}
      >
        <h2 className=" text-indigo-700 flex items-center gap-2">
           Work Breakdown Structure
        </h2>

        <div className="flex items-center gap-2">
          <label className=" text-gray-700">Level</label>
          <input
            type="number"
            min={0}
            value={activityLevel}
            onChange={(e) => setActivityLevel(Number(e.target.value))}
            className="w-16 rounded border border-gray-300 px-2 py-1 "
          />
        </div>
      </div>

     {/*  <div className="min-h-0 flex-1 overflow-y-auto p-4">
        <ThirdWBS
          projectId={projectId}
          activityLevel={activityLevel}
          onActivityClick={(activityId, wbsId) => {
            setSelectedActivityId(activityId);
            setSelectedWbsId(wbsId);
            setRightView("activity");
          }}
          onWbsClick={(wbsId) => {
            setSelectedActivityId(null);
            setSelectedWbsId(wbsId);
            setRightView("wbs");
          }}
        />
      </div> */}
        <div className="flex-1 min-h-0 overflow-y-auto p-0 m-0">  
<ThirdWBS
  projectId={projectId}
  projectName={projectName}
  activityLevel={activityLevel}
  onActivityClick={(activityId, wbsId) => {
    setSelectedActivityId(activityId);
    setSelectedWbsId(wbsId);
    setRightView("activity");
  }}
  onWbsClick={(wbsId) => {
    setSelectedActivityId(null);
    setSelectedWbsId(wbsId);
    setRightView("wbs");
  }}
/>
</div>
    </div>
  </Panel>

  
  <PanelResizeHandle className="w-px bg-gray-500 cursor-col-resize flex-shrink-0" />

  {/* RIGHT PANEL */}
  <Panel defaultSize={75} minSize={25}>
    <div
    //  className="flex h-full min-h-0 flex-1 overflow-y-auto"
      className="small-scrollbar flex h-full min-h-0 flex-1 overflow-y-auto"

      style={{ backgroundColor: "#FFFFFF" }}
    >
      {rightView === "activity" ? (
  <MetricsAccordionTable
    activityId={selectedActivityId}
    wbsId={selectedWbsId}
  />
) 
/* : 
rightView === "wbs" ? (
 <NotationAccordionMatrixPanel
   <NotationExcelSheet
    selectedWorkTreeNode={selectedWbsId}
  />
) */
 : (
  <div className="flex h-full w-full items-center justify-center text-gray-500">
    Select a WBS or Activity from the left panel.
  </div>
)}
    </div>
  </Panel>
</PanelGroup>

      </div>
    </div>
  );
};

export default ThirdtabPanel;